<template>
  <div class="city-select">
    <select v-model="selectedProvince" name="province">
      <option v-for="(item, index) in provinces"
              v-if="item.level === 1"
              :value="item">
        {{ item.name }}
      </option>
    </select>
    <select v-model="selectedCity" name="city">
      <option
        v-for="(item, index) in cities"
        :value="item">
        {{ item.name }}
      </option>
    </select>
    <select v-model="selectedBlock" name="block">
      <option
        v-for="(item, index) in blocks"
        :value="item">
        {{ item.name }}
      </option>
    </select>
  </div>
</template>
<script>
  /**
   *  省 市 区/县城  三联动选择器
   */
  import provinces from '../../plugins/provinces.js'
  import Vue from 'vue'
  export default {
    props: {
      provinceName: {
        type: String,
        default () {
          return null
        },
      },
      cityName: {
        type: String,
        default () {
          return null
        },
      },
      blockName: {
        type: String,
        default () {
          return null
        },
      },
    },
    name: 'app',
    created () {
      // 数据初始化,默认选中北京市,默认选中第一个;北京市数据为总数据的前18个
      let beijing = this.provinces.slice(0, 19)
      this.cities = beijing.filter(item => {
        if (item.level === 2) {
          return true
        }
      })
      this.selectedCity = this.cities[0]
      this.blocks = beijing.filter(item => {
        if (item.level === 3) {
          return true
        }
      })
      this.selectedBlock = this.blocks[0]
    },
    watch: {
      provinceName (val) {
        let self = this
        if (val) {
          self.selectAreaByAreaName(val, this.cityName, this.blockName)
        }
      },
      selectedProvince (newVal, oldVal) {
        // 港澳台数据只有一级,特殊处理
        if (newVal.sheng === '71' || newVal.sheng === '81' || newVal.sheng === '82') {
          this.cities = [newVal]
          this.blocks = [newVal]
        } else {
          this.cities = this.provinces.filter(item => {
            if (item.level === 2 && item.sheng && newVal.sheng === item.sheng) {
              return true
            }
          })
        }
        // 此时在渲染DOM,渲染结束之后再选中第一个
        Vue.nextTick(() => {
          if (this.cityName) {
            return
          }
          this.selectedCity = this.cities[0]
          this.$emit('input', this.info)
        })
      },
      selectedBlock () {
        if (this.blockName) {
          return
        }
        Vue.nextTick(() => {
          this.$emit('input', this.info)
        })
      },
      selectedCity (newVal) {
        // 选择了一个市,要选择区了 di是城市的代表,sheng
        if (newVal.sheng === '71' || newVal.sheng === '81' || newVal.sheng === '82') {
          this.blocks = [newVal]
          this.cities = [newVal]
        } else {
          this.blocks = this.provinces.filter(item => {
            if (item.level === 3 && item.sheng && item.sheng === newVal.sheng && item.di === newVal.di && item.name !== '市辖区') {
              return true
            }
          })
        }
        Vue.nextTick(() => {
          if (this.blockName) {
            return
          }
          this.selectedBlock = this.blocks[0]
          // 触发与 v-model相关的 input事件
          this.$emit('input', this.info)
        })
      }
    },
    computed: {
      info () {
        return {
          province: this.selectedProvince,
          city: this.selectedCity,
          block: this.selectedBlock
        }
      }
    },
    data () {
      return {
        selectedProvince: provinces[0],
        selectedCity: 0,
        selectedBlock: 0,
        cities: 0,
        provinces,
        blocks: 0
      }
    },
    methods: {
      selectAreaByAreaName (province, city, block) {
        for (var index = 0; index < this.provinces.length; index++) {
          if (this.provinces[index].name === province) {
            this.selectedProvince = this.provinces[index]
          }
          if (this.provinces[index].name === city) {
            this.selectedCity = this.provinces[index]
          }
          if (this.provinces[index].name === block) {
            this.selectedBlock = this.provinces[index]
          }
        }
        this.$emit('input', this.info)
      },
    }
  }
</script>




// WEBPACK FOOTER //
// CitySelect.vue?0e8444ae